import ReactDOM from 'react-dom';
import {
  FC,
  useRef,
  useContext,
  CSSProperties,
  memo,
} from 'react';
// 组件
import { DownOutlined, RollbackOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { ProSpace, ProFloatButton, ProRadio, ProDropdown, ProButton, } from '../../antd';
import Steps from '../../Steps';
import OperationButton from '../../OperationButton';
// 方法
import classnames from 'classnames';
import StrategyCountext from '../context/strategyCountext';
import { useLayoutContext } from '../../PageLayout/context/LayoutContext';
import { getHTMLElement } from '../../utils/utils';
import { getTitle } from '../util';
// 常量
import {
  TABLE_OK_BUTTON_ID,
  TABLE_CANCEL_BUTTON_ID,
  TABLE_DETAIL_BUTTON_ID,
} from '../../constants/constant';
import { FormModalActionType } from '../../FormModal/interface';
import { IBaseStrategyPageProps, sizeenum } from '../interface';

export interface BaseStrategyPageProps extends IBaseStrategyPageProps {
  onOk?: () => void; // 点击确定回调
}

const BaseStrategyPage: FC<BaseStrategyPageProps> = memo(props => {
  const {
    backText,
    title,
    footer,
    okType,
    okText,
    confirmLoading,
    okButtonProps,
    cancelText,
    detailText,
    detailType,
    detailButtonProps,
    textAlign,
    editButtonAuthorityCode,
    isEditAuth,
    size,
    width,
    getContainer,
    hideOkButton,
    contentStyle,
    otherButtons,
    headClassName,
    bodyClassName,
    isFullPage,
    minWidth,
    hideBack,
    headerProps,
    footerNode,
    footerClassName,
    footerStyle,
    addButtonText,
    editButtonText,
    cancelEditButtonText,
    showCancelEditButton,
    onBack,
    onOk,
    onDetail,
    onClickOtherButton,
    onCancelEdit,
    children,
  } = props;
  const renderRef = useRef<HTMLElement>();
  const detailBodyRef = useRef<HTMLDivElement>(null);
  const formModalRef = useRef<FormModalActionType>();
  const { dispatch } = useLayoutContext();
  const { pageType, dispatch: dispatchDetailPage } = useContext(StrategyCountext);
  const currentTitle = title || getTitle(pageType);
  // 返回
  const handleBack = () => {
    dispatchDetailPage('change', { visible: false });
    onBack?.();
  };
  // 确定
  const handleOk = () => {
    onOk?.();
  };
  // 编辑
  const handleEdit = () => {
    dispatchDetailPage('change', { pageType: 'edit' });
    onDetail?.();
  };
  // 取消编辑
  const handleCancelEdit = () => {
    dispatchDetailPage('change', { pageType: 'detail' });
    onCancelEdit?.();
  };
  // 草稿箱
  const handleDrafte = () => {
    formModalRef.current?.show();
  };
  const getFooter = () => {
    if (footer === false) return;
    if (Array.isArray(footer)) {
      const firstFooter = footer.slice(0, 1);
      const restFooter = footer.slice(1);
      return (
        <ProSpace align="center" size="middle">
          {firstFooter}
          {restFooter}
        </ProSpace>
      );
    }
    return (
      <ProSpace align="center" size="middle">
        {hideOkButton || !pageType ? null : pageType === 'detail' ? (
          <>
            {
              (
                (isEditAuth === undefined || isEditAuth === true) ||
                (!editButtonAuthorityCode || dispatch('isAuthority', editButtonAuthorityCode)))
                ? (
                  <OperationButton.Edit
                    id={TABLE_OK_BUTTON_ID}
                    key="2"
                    type={detailType}
                    {...detailButtonProps}
                    onClick={handleEdit}
                    text={detailText}
                  />
                ) : null
            }
          </>
        ) : (
          <>
            <OperationButton.Submit
              id={TABLE_DETAIL_BUTTON_ID}
              key="4"
              type={okType}
              loading={confirmLoading}
              {...okButtonProps}
              onClick={handleOk}
              text={(pageType === 'add' ? addButtonText : editButtonText) || okText}
            />
            {
              showCancelEditButton && pageType === 'edit' && (
                <OperationButton.Cancel
                  key='5'
                  onClick={handleCancelEdit}
                  text={cancelEditButtonText}
                />
              )
            }
          </>
        )}
        {
          Array.isArray(otherButtons) && !!otherButtons.length && (
            <>
              {
                otherButtons.map(item => {
                  if (Array.isArray(item)) {
                    if (!item.length) return null;
                    return (
                      <ProRadio.Group
                        optionType="button"
                        buttonStyle="outline"
                        disabled={pageType !== 'detail'}
                      >
                        {
                          item.map(v => {
                            if (v.render) {
                              const renderClasses = classnames('detail-render-button', {
                                disabled: v.disabled || pageType !== 'detail',
                              });
                              return (
                                <div
                                  className={renderClasses}
                                  key={v.key}
                                  onClick={() => {
                                    !v.disabled && onClickOtherButton?.(v.key)
                                  }}
                                >
                                  {v.icon}
                                  <span className={v.icon ? 'button-icon-left' : undefined}>{v.render}</span>
                                </div>
                              );
                            }
                            return (
                              <ProRadio.Button
                                key={v.key}
                                value={v.key}
                                disabled={v.disabled}
                                onClick={() => onClickOtherButton?.(v.key)}
                              >
                                <span>{v.icon}</span>
                                <span className='button-icon-left'>{v.label}</span>
                              </ProRadio.Button>
                            );
                          })
                        }
                      </ProRadio.Group>
                    );
                  }
                  if (item.label && Array.isArray(item.buttonList) && item.buttonList.length) {
                    const items: MenuProps['items'] = [];
                    item.buttonList.forEach(item => {
                      items.push({
                        key: item.key,
                        icon: item.icon,
                        label: item.render || item.label,
                      });
                    });
                    return (
                      <ProDropdown
                        key={item.key}
                        trigger={['click']}
                        disabled={pageType !== 'detail'}
                        menu={{
                          items,
                          onClick: v => onClickOtherButton?.(v.key),
                        }}
                      >
                        <ProButton icon={item.icon}>
                          {item.label}
                          <DownOutlined />
                        </ProButton>
                      </ProDropdown>
                    );
                  }
                  return null;
                })
              }
            </>
          )
        }
        <OperationButton.Cancel
          id={TABLE_CANCEL_BUTTON_ID}
          key="6"
          type="default"
          onClick={handleBack}
          text={cancelText}
        />
      </ProSpace>
    );
  };
  const classes = classnames('tl-detail-body', bodyClassName, {
    [`content-${textAlign}`]: textAlign,
  });
  let contentStype: CSSProperties = { ...contentStyle };
  if (isFullPage) contentStype.height = '100%';
  if (size) {
    contentStype.width = sizeenum[size];
  }
  if (width) {
    if (typeof width === 'number') {
      contentStype.width = `${width}px`;
    }
    if (typeof width === 'string') {
      if (width.endsWith('%')) {
        contentStype.width = `${window.parseInt(width, 10)}%`;
      } else {
        contentStype.width = `${window.parseInt(width, 10)}px`;
      }
    }
  }
  if (minWidth) {
    contentStype.minWidth = `${minWidth}px`;
  }
  const headClasses = classnames('tl-detail-head', headClassName, {
    'head-steps': headerProps,
  });
  const footerClasses = classnames('tl-detail-footer', footerClassName);
  const renderHTML = (
    <div className="tl-detail">
      <div className={headClasses}>
        <div className="tl-detail-head-top">
          <div className="tl-detail-head-top-title">
            {!hideBack && (
              <div
                className="tl-detail-head-top-title-back"
                onClick={handleBack}
              >
                <RollbackOutlined className='p-r-s' />
                <span>{backText}</span>
              </div>
            )}
            <div className="tl-detail-head-top-title-name">{currentTitle}</div>
          </div>
          <div className="tl-detail-head-top-operation">{getFooter()}</div>
        </div>
        {!!headerProps && (
          <Steps className="tl-detail-head-steps" {...headerProps} />
        )}
      </div>
      <div className={classes} ref={detailBodyRef}>
        <div className="tl-detail-body-content" style={contentStype}>
          {children}
        </div>
        <ProFloatButton.BackTop
          visibilityHeight={400}
          target={() => detailBodyRef.current || document.body}
        />
      </div>
      {
        !!footerNode && (
          <div className={footerClasses} style={footerStyle}>
            {footerNode}
          </div>
        )
      }
    </div>
  );
  if (getContainer) {
    if (!renderRef.current) {
      const el = getHTMLElement(getContainer);
      if (el) {
        renderRef.current = el;
        return ReactDOM.createPortal(renderHTML, el);
      }
      return null;
    }
    return ReactDOM.createPortal(renderHTML, renderRef.current);
  }
  return renderHTML;
});

BaseStrategyPage.defaultProps = {
  backText: '返回',
  okType: 'primary',
  cancelType: 'default',
  okText: '确定',
  addButtonText: '确定',
  editButtonText: '保存',
  cancelEditButtonText: '取消编辑',
  confirmLoading: false,
  cancelText: '关闭',
  detailType: 'primary',
  detailText: '编辑',
  hideOkButton: false,
  hideBack: false,
  showCancelEditButton: false,
};

export default BaseStrategyPage;
